module.exports = __webpack_public_path__ + "img/category-brand-hover.d555c3d6.png";